var data = [
	{
		layers: [
			{
				name: "Metal Deck",
				thickness: 0.01
			},
			{
				name: "Metal - Steel",
				thickness: 0.15
			}
		],
		modCategory: "BFA",
		modType: "01",
		modulousId: "BFA|01|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "balcony floor cassette",
		totalThickness: 0.16,
		size: [
			null,
			0.16,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Sheathing Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.1
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			}
		],
		modCategory: "WPA",
		modType: "01",
		modulousId: "WPA|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "perimeter_12.5-100-25",
		totalThickness: 0.1375,
		size: [
			null,
			null,
			0.1375
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Concrete, Sand/Cement Screed",
				thickness: 0.065
			},
			{
				name: "Metal - Steel",
				thickness: 0.23
			}
		],
		modCategory: "FPA",
		modType: "02",
		modulousId: "FPA|02|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "module floor cassette_230ste-65scr",
		totalThickness: 0.295,
		size: [
			null,
			0.295,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.07
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			}
		],
		modCategory: "WPB",
		modType: "01",
		modulousId: "WPB|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "partition_12.5-70-12.5",
		totalThickness: 0.095,
		size: [
			null,
			null,
			0.095
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DCD",
		modType: "01",
		modPartNumber: "UK-DCD0001",
		modulousId: "DCD|01|UK-DCD0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door glazed double",
		rvFamilyType: "dcs-01_2040x1654_01s (2115hx1788w s/o)",
		totalThickness: 0,
		size: [
			1.7379999999999713,
			2.0900000000000003,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DID",
		modType: "02",
		modPartNumber: "UK-DID0002",
		modulousId: "DID|02|UK-DID0002",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door plain double",
		rvFamilyType: "did-02_2300x1414_01s (2375hx1548w s/o)",
		totalThickness: 0,
		size: [
			1.4979999999999891,
			2.3500000000000054,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "02",
		modPartNumber: "UK-DIS0002",
		modulousId: "DIS|02|UK-DIS0002",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door single",
		rvFamilyType: "dis-02_2040x826_01s (2115hx960w s/o)",
		totalThickness: 0,
		size: [
			0.9099999999999983,
			2.089999999999999,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Sheathing Board_Generic",
				thickness: 0.018
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.107
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.015
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.015
			}
		],
		modCategory: "CPA",
		modType: "05",
		modulousId: "CPA|05|",
		rgTypes: [
			"Ceiling"
		],
		rvFamilyName: "basic roof",
		rvFamilyType: "18-100-30",
		totalThickness: 0.155,
		size: [
			null,
			0.155,
			null
		],
		color: "#5ea0bb",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "01",
		modPartNumber: "UK-DIS0001",
		modulousId: "DIS|01|UK-DIS0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "placeholder door single",
		rvFamilyType: "dis-01_2040x926_01s (2115hx1060w s/o)",
		totalThickness: 0,
		size: [
			1.0099999999999993,
			2.089999999999999,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "WNF",
		modType: "01",
		modPartNumber: "UK-WNF0002",
		modulousId: "WNF|01|UK-WNF0002",
		rgTypes: [
			"Window"
		],
		rvFamilyName: "placeholder window 2",
		rvFamilyType: "wnf-01_800x1600_01s (so 850hx1650w)",
		totalThickness: 0,
		size: [
			1.5999999999999999,
			0.7999999999999978,
			0.1375
		],
		color: "#4b5e82",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "02",
		modulousId: "PFC|02|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_230x90x32",
		size: [
			null,
			0.23000049591064453,
			0.09000015258789062
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "03",
		modulousId: "PFC|03|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_125x65x15",
		size: [
			null,
			0.125,
			0.06500005722045898
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "04",
		modulousId: "PFC|04|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_100x50x10",
		size: [
			null,
			0.10000038146972656,
			0.05000019073486328
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Brick, Common",
				thickness: 0.036
			},
			{
				name: "Air",
				thickness: 0.066
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.26
			}
		],
		modCategory: "FCD",
		modType: "02",
		modulousId: "FCD|02|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Sheathing Board_Knauf",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.1
			},
			{
				name: "Sheathing Board_Knauf",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.054
			},
			{
				name: "Metal - Aluminum",
				thickness: 0.006
			}
		],
		modCategory: "PAR",
		modType: "01",
		modulousId: "PAR|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "parapet generic",
		totalThickness: 0.185,
		size: [
			null,
			null,
			0.185
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Vegetation Blanket",
				thickness: 0.065
			},
			{
				name: "HyrdoSoil Substrate",
				thickness: 0.06
			},
			{
				name: "Air Infiltration Barrier",
				thickness: 0.01
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.355
			},
			{
				name: "Plywood, Sheathing",
				thickness: 0.01
			}
		],
		modCategory: "RFB",
		modType: "01",
		modulousId: "RFB|01|",
		rgTypes: [
			"Roof"
		],
		rvFamilyName: "basic roof",
		rvFamilyType: "roof generic",
		totalThickness: 0.5,
		size: [
			null,
			0.5,
			null
		],
		color: "#ebeced",
		sizeLock: [
			false,
			true,
			false
		]
	}
];

export { data as default };
//# sourceMappingURL=combined-rv-data.json.js.map
